import Api from '@/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useRouter } from 'next/navigation';
import { ROUTES } from '@/routes/constants';
import { PROFILE_QUERY_KEY } from '@/modules/profile/queries';

export const useSignIn = () => {
  const queryClient = useQueryClient();
  const router = useRouter();

  return useMutation({
    mutationFn: ({ email, password }: { email: string; password: string }) => Api.signIn(email, password),
    onSuccess: async (user) => {
      queryClient.setQueryData(PROFILE_QUERY_KEY, user);
      router.replace(ROUTES.Index);
    },
  });
};

export const useSignUp = () => {
  const queryClient = useQueryClient();
  const router = useRouter();

  return useMutation({
    mutationFn: (payload: { email: string; password: string }) => Api.signUp(payload),
    onSuccess: async (user) => {
      queryClient.setQueryData(PROFILE_QUERY_KEY, user);
      router.replace(ROUTES.Index);
    },
  });
};

export const useSignOut = () => {
  const queryClient = useQueryClient();
  const router = useRouter();

  return useMutation({
    mutationFn: () => Api.signOut(),
    onSuccess: async () => {
      queryClient.setQueryData(PROFILE_QUERY_KEY, null);
      queryClient.clear();
      router.replace(ROUTES.SignIn);
    },
  });
};

export const useForgotPassword = () => {
  return useMutation({
    mutationFn: (email: string) => Api.forgotPassword(email),
  });
};

export const useResetPassword = () => {
  return useMutation({
    mutationFn: ({ token, password }: { token: string; password: string }) => Api.resetPassword(token, password),
  });
};

export const useChangePassword = () => {
  return useMutation({
    mutationFn: ({ old_password, new_password }: { old_password: string; new_password: string }) =>
      Api.changePassword(old_password, new_password),
  });
};
